import { toastRef } from '../components/GlobalToast';
import { useCallback } from 'react';

export interface ToastOptions {
  /** Display time in milliseconds; overrides the 3 s default of GlobalToast. 0 keeps the toast until it is closed. */
  timeOut?: number;
}

export function useToast() {
  const showToast = useCallback((
    type: 'success' | 'error' | 'warning' | 'info',
    title: string,
    content: string,
    options?: ToastOptions
  ) => {
    const cssClassMap = {
      success: 'e-toast-success',
      error: 'e-toast-error',
      warning: 'e-toast-warning',
      info: 'e-toast-info'
    };

    toastRef.current?.show({
      title,
      content,
      cssClass: cssClassMap[type] || 'e-toast-info',
      ...(options?.timeOut !== undefined ? { timeOut: options.timeOut } : {}),
    });
  }, []);

  return { showToast };
}
// This hook provides a function to show toast notifications.
// It uses a reference to a ToastComponent to display the toast with a title, content, and optional CSS class.
